import { yupResolver } from '@hookform/resolvers/yup';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetEmailTemplateQuery } from 'api/client-domain/email-template-service/email-template-service';
import { useQueryWithForm } from 'hooks/rtkq.hooks';
import { useForm } from 'react-hook-form';
import { emailTemplateFormSchema } from './email-template-form.schema';
import { EmailTemplateResult } from 'api/client-domain/email-template-service/email-template-service.types';
import { useEffect } from 'react';

export const useEmailTemplateForm = (
  template?: Partial<EmailTemplateResult>,
) => {
  const getEmailTemplateQueryResult = useGetEmailTemplateQuery(
    template?.templateId ? { id: template?.templateId } : skipToken,
  );

  const form = useForm({
    resolver: yupResolver(emailTemplateFormSchema),
    defaultValues: emailTemplateFormSchema.cast(template),
  });

  useQueryWithForm(form, getEmailTemplateQueryResult, emailTemplateFormSchema);

  useEffect(() => {
    if (!template?.templateId)
      form.reset(emailTemplateFormSchema.cast(template));
  }, [form, template]);

  return { form };
};
